import { Component } from '@angular/core';

@Component({
  selector: 'pl-header',
  templateUrl: './pl-header.component.html',
  styleUrls: ['./pl-header.component.scss'],
})
export class PlHeaderComponent {}
